import React from "react";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import IDataFilterSelectInputValue from "../selectBox/IDataFilterSelectInputValue";
import {convertCodeToLabel} from "features/shared/helpers/currencyHelper";
import IDataFilterProps from "../IDataFilterProps";
import { useTranslation } from "react-i18next";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

const DataFilterSelectInputBoxCurrency = (props: IDataFilterProps) => {
  // translations
  const tLables = useTranslation("shared\\dataFilters").t;
  
  const selectInputValue = props.filterDescriptor
    .value as IDataFilterSelectInputValue;

  const setDescriptorValue = (name: string, value: string) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === name);

    // Nastavím hodnotu
    let selectedValue = descriptor?.value as IDataFilterSelectInputValue;
    selectedValue.value = value;

    props.setDescriptors(newDescriptors);
  };

  const getData = (): any[] => {
    if (
      props.externalData &&
      selectInputValue.external &&
      props.externalData.length > 0
    ) {
      const externalDataValue = props.externalData.find(
        (x) => x.name === props.filterDescriptor.name
      );

      if (externalDataValue) {
        return externalDataValue.data as any[];
      }
    }

    return selectInputValue.options;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDescriptorValue(event.target.name, event.target.value);
  };

  return (
    <SelectInput
      reactKey={props.reactKey}
      name={props.filterDescriptor.name}
      label={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      defaultValueLabel={getTranslatedFormText(props.filterDescriptor, "placeholder", tLables)}
      value={selectInputValue.value}
      options={getData()}
      optionName={selectInputValue.optionName}
      optionValue={selectInputValue.optionValue}
      optionNameConvert={convertCodeToLabel}
      onChange={handleOnChange}
    />
  );
};

export default DataFilterSelectInputBoxCurrency;
